module.exports = __webpack_public_path__ + "img/toa-heftiba-6bKpHAun4d8-unsplash.02a010b2.jpg";